export default __webpack_public_path__ + "static/media/000805060408020506.b78e8fc1.mp4";